import React from "react";
import { withRouter } from "react-router-dom";
import MyContext from "../../../api/context/my-context";

class ModalTreeChildren extends React.Component {
  constructor(props) {
    super(props);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleEvent = this.handleEvent.bind(this);

    this.state = {
      TreeList: props.TreeList,
      componentName: props.componentName,
      pathname: props.pathname,
      activeIndex: 0,
    };
  }

  handleCheck(index, e) {
    document
      .getElementById("tree-parent-id")
      .setAttribute("value", e.currentTarget.dataset.id);
    document
      .getElementById("tree-parent-name")
      .setAttribute("value", index.name);
    this.setState({ activeIndex: index });
    e.stopPropagation();
  }

  componentDidMount() {
    var tree = document.querySelectorAll(".map_menu");
    for (var i = 0; i < tree.length; i++) {
      tree[i].addEventListener("click", function (e) {
        var element = e.target.parentElement;
        var parent = element.parentElement;
        var opensubs = parent.querySelectorAll(":scope .open");
        var classList = element.classList;

        var a_element = element.children[0];
        var a_classList = a_element.classList;

        if (opensubs.length !== 0) {
          for (var i = 0; i < opensubs.length; i++) {
            opensubs[i].classList.remove("open");
            opensubs[i].children[0].classList.remove("active");
          }
        }

        classList.add("open");
        a_classList.add("active");
      });
    }
  }

  TreeChildren = (data) => {
    return (
      <ul className="">
        {data &&
          data.map((item) => (
            <li
              id={item.id}
              key={item.id.toString()}
              data-id={item.id}
              onClick={this.handleCheck.bind(this, item)}
              className={
                item.children && item.children.length > 0
                  ? "second haschild"
                  : "second"
              }
              name={
                item.children && item.children.length > 0
                  ? "haschild"
                  : ""
              }
            >
              <a href="javascript:void(0)">{item.name} </a>
              {item.children && item.children.length > 0
                ? this.TreeChildren(item.children)
                : ""}
            </li>
          ))}
      </ul>
    );
  };

  handleEvent() {
    this.state = {
      TreeList: this.props.TreeList,
      componentName: this.props.componentName,
      pathname: this.props.pathname,
      activeIndex: 0,
    };
  }

  Tree = (data) => {
    return (
      <ul className="map_menu">
        {data &&
          data.map((item) => (
            <MyContext.Consumer>
              {(context) => (
                <li
                  id={item.id}
                  key={item.id.toString()}
                  data-id={item.id}
                  onClick={
                    (this.handleCheck.bind(this, item),
                    () => context.actions.treeClickButton(true))
                  }
                  className={
                    item.children && item.children.length > 0
                      ? "halfwidth haschild"
                      : "halfwidth"
                  }
                >
                  <a href="javascript:void(0)">{item.name} </a>
                  {item.children && item.children.length > 0
                    ? this.TreeChildren(item.children)
                    : ""}
                </li>
              )}
            </MyContext.Consumer>
          ))}
      </ul>
    );
  };

  render() {
    this.handleEvent();
    return (
      <div>
        {this.Tree(
          this.state.TreeList,
          this.state.componentName,
          this.state.pathname
        )}
      </div>
    );
  }
}

export default withRouter(ModalTreeChildren);
